import { t } from "../../../data/strings";
import {
  spendableMana as simSpendableMana,
  type InfiniteWarState,
  type IwTeam,
} from "../infinite-war-rules";

/** Re-export sim spendable mana for HUD affordability display. */
export const spendableMana = simSpendableMana;

/** Regen mana line only (soul bank rolled back). */
export function formatTeamManaLine(
  state: InfiniteWarState,
  team: IwTeam = "south",
): string {
  return t("iw.mana", {
    mana: state.mana[team].toFixed(1),
    cap: String(state.manaCap),
  });
}
